import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function notesReducer(state = initialState.displayNotes, action) {
    switch(action.type){

        case types.SET_NOTES_DISPLAY:

            //debugger;
            //use immutable state with es6's spread operator (...) on existing state and Object.assign to make a deep copy of existing object to create a brand new state
            return action.displayNotes;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/reducers/notesReducer.js
 **/